// src/components/ViewBOMChemicals.jsx

import React, { useState, useEffect } from "react";
import TableTemplate from "./TableTemplate";
import { Button, Box, Drawer, Typography, CircularProgress } from "@mui/material";
import axios from "axios";
import env from "react-dotenv";

const ViewBOMChemicals = ({ bomId, partId }) => {
    const [data, setData] = useState([]);
    const [open, setOpen] = useState(false);
    const [editData, setEditData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [expandedDrawer, setExpandedDrawer] = useState(false); // State for drawer expansion

    useEffect(() => {
        fetchData(bomId, partId);
    }, [bomId, partId]);

    const fetchData = async (bomId, partId) => {
        try {
            let url;
            if (bomId && partId) {
                url = `${process.env.REACT_APP_PJCBACKEND_URL}/api/bom-chemicals/${bomId}/${partId}`;
            } else {
                url = `${process.env.REACT_APP_PJCBACKEND_URL}/api/bom-chemicals`; // Fetch all records if no bomId and partId
            }
            const response = await axios.get(url);
            setData(response.data);
        } catch (error) {
            console.error("Error fetching data:", error);
            setError("Failed to fetch BOM chemicals data.");
        } finally {
            setLoading(false);
        }
    };

    const handleAdd = () => {
        setEditData(null);
        setOpen(true);
        setExpandedDrawer(false); // Reset to not expanded when adding a new entry
    };

    const handleEdit = (item) => {
        setEditData(item);
        setOpen(true);
        setExpandedDrawer(false); // Reset to not expanded when editing
    };

    const handleDelete = async (id) => {
        try {
            console.log("Deleting BOM Chemical with ID:", id);
            await axios.delete(`${process.env.REACT_APP_PJCBACKEND_URL}/api/bom-chemicals/${id}`);
            setData(data.filter(item => item.id !== id));
        } catch (error) {
            console.error("Error deleting record:", error);
        }
    };

    const handleClose = () => {
        setOpen(false);
        setExpandedDrawer(false); // Reset drawer expansion on close
    };

    const handleSave = async (item) => {
        try {
            console.log("Saving BOM Chemical data:", item);
            if (item.id) {
                await axios.put(`${process.env.REACT_APP_PJCBACKEND_URL}/api/bom-chemicals/${item.id}`, item);
            } else {
                await axios.post(`${process.env.REACT_APP_PJCBACKEND_URL}/api/bom-chemicals`, item);
            }
            fetchData(bomId, partId); // Refresh data after save
        } catch (error) {
            console.error("Error saving record:", error);
        }
        setOpen(false);
        setExpandedDrawer(false); // Reset drawer expansion on save
    };

    const transformedData = data.map(item => ({
        ...item,
        // Add any transformations needed for display
    }));

    if (loading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
                <CircularProgress />
            </Box>
        );
    }

    if (error) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
                <Typography variant="h6" color="error">No records found</Typography>
            </Box>
        );
    }

    return (
        <Box
        sx={{
            height: 670,
            width: '85%',
            marginLeft:"210px",
            marginRight:"150px",
          }}
        >
            <TableTemplate
                columns={["", "part_name", "chemical_name", "chemical_quantity"]}
                headers={{
                    columns: ["", "Raw Material Name", "Chemical Name", "Chemical Quantity"]
                }}
                iterate={transformedData}
                data={transformedData}
                onDelete={handleDelete}
                // onEdit={handleEdit}
                // onAdd={handleAdd}
                // add
                // edit
            />

            {/* <Drawer
                anchor="right"
                open={open}
                onClose={handleClose}
                sx={{
                    "& .MuiDrawer-paper": { width: expandedDrawer ? "800px" : "600px" } // Expand when form is open
                }}
            > */}
                {/* AddEditBOMChemical component can be added here */}
            {/* </Drawer> */}
        </Box>
    );
};

export default ViewBOMChemicals;